import { fetchHil } from "../utils";

export default {
  namespaced: true,
  state: {
    signatureTemplates: {},
  },
  mutations: {
    setSignatureTemplates(state, { signatureTemplates, count }) {
      state.signatureTemplates = {
        items: signatureTemplates,
        count
      };
    }
  },
  actions: {
    async fetchSignatureTemplates({ commit }) {
      const resp = await fetchHil(`/signature-templates`, {
        method: "GET"
      });

      const signatureTemplates = await resp.json();
      commit("setSignatureTemplates", {
        signatureTemplates,
        count: +resp.headers.get("x-total-count")
      });
    }
  }
};
